var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('Header'),_c('div',{staticClass:"wrapper"},[_c('ImgBackground'),_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1)],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }